import jwt from 'jsonwebtoken';
import jsCookie from 'js-cookie';
import { WIDGET_TYPE } from 'moet-core/src/constants';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import { COOKIES } from '../constants';

const getWidgetTokenFromCookie = () => jsCookie.get(COOKIES.WIDGET_TOKEN);

export const getEncodedWidgetCookieFromParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');

  // For the UNMANAGED_KYC flow we expect the token to be in a cookie to prevent attacks like:
  // https://jira.int.klarna.net/jira/browse/VM-1030
  if (urlParams.get('frontend_type') === WIDGET_TYPE.UNMANAGED_KYC) {
    // For cypress tests we load the flow with an URL token, so we return that token in this case
    return getWidgetTokenFromCookie() || (isRunningContextCypress(window) ? urlToken : null);
  }

  return urlToken;
};

export const getDecodedWidgetToken = () => {
  const encodedToken = getEncodedWidgetCookieFromParams();

  if (encodedToken) {
    return jwt.decode(encodedToken);
  }

  return null;
};

export const isWidget = () => {
  const decodedToken = getDecodedWidgetToken();

  if (decodedToken && decodedToken.mid) {
    return true;
  }

  return false;
};

export const getWidgetToken = () => {
  const decodedToken = getDecodedWidgetToken();

  let token;
  if (decodedToken && decodedToken.token) {
    token = decodedToken.token;
  }
  return token;
};
